import { render } from "./FungiDataMaterial.vue?vue&type=template&id=89c9f6ea"
import script from "./FungiDataMaterial.vue?vue&type=script&lang=js"
export * from "./FungiDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__